import { faroCoreApiClient } from "@api/faro-core-api-client";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { RootState } from "@store/store-helper";

/**
 * Fetches active members from the backend so they can be put into the store
 * @throws {HttpUtils.FetchError} if the Core API client request fails and not in dev mode
 */
export const fetchActiveMembers = createAsyncThunk<
  FaroCoreApiTypes.CompanyMemberBase[],
  BaseCompanyIdProps,
  { state: RootState }
>(
  "activeMembers/fetchActiveMembers",
  async ({ companyId }) => {
    return await faroCoreApiClient.company.getActiveMembers({ companyId });
  },
  {
    condition: (_, { getState }) => {
      const state = getState();

      // Skip fetching if active members have already been fetched or fetching is in progress
      return state.activeMembers.fetching.status !== "succeeded";
    },
  }
);
